import { useState, useCallback, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import dateUtils from 'shared/src/date'
import bookActions from 'store/modules/booking'
import bookSelectors from 'store/selectors/booking'
import routerActions from 'store/modules/router'
import routerSelectors from 'store/selectors/router'
import useCalendar from './useCalendar'

import {
  TODAY,
} from './utils'

const usePublicCalendar = ({
  project,
  bookingform,
  config,
} = {}) => {

  const dispatch = useDispatch()

  const params = useSelector(routerSelectors.params)
  const [ slotFilter, setSlotFilter ] = useState('all')

  const onUpdateDate = useCallback((date) => {
    dispatch(routerActions.addQueryParams({date}))
  }, [])

  const calendarConfig = useMemo(() => {
    const calendarConfig = config ? config.calendar_config || {} : {}
    let min = calendarConfig.min
    if(calendarConfig.min && dateUtils.isBeforeOrSame(TODAY, calendarConfig.min)) {
      min = TODAY
    }
    return Object.assign({}, calendarConfig, {min})
  }, [
    config,
  ])

  // this is fixed by the config
  const condensed = useMemo(() => {
    return calendarConfig.condensed ? true : false
  }, [
    calendarConfig,
  ])

  const days = useMemo(() => {
    return calendarConfig.public_days || 1
  }, [
    calendarConfig,
  ])

  const baseCalendar = useCalendar({
    project,
    bookingform,
    admin: false,
    days,
    reloadDelay: 5000,
    initialDate: params.date,
    config,
    calendarConfig,
    condensed,
    slotFilter,
    dataSelector: bookSelectors.calendar,
    loadDataAction: bookActions.loadCalendar,
    onUpdateDate,
  })

  return Object.assign({}, baseCalendar, {
    setSlotFilter,
  })
}

export default usePublicCalendar